import React from 'react';
import { ROAST_LAB_CONTENT } from './content';

interface Props { isZh: boolean }

export const RoastLabIntroV2: React.FC<Props> = ({ isZh }) => {
  const { intro } = ROAST_LAB_CONTENT;
  return (
    <section style={{ background: '#FAF9F1' }}>
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="aspect-[4/5] overflow-hidden">
          <img src={intro.image} alt="" className="w-full h-full object-cover" />
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-black/50 mb-6">
            {isZh ? intro.eyebrow.zh : intro.eyebrow.en}
          </p>
          <h2
            className="text-black mb-10 leading-[1.15]"
            style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(34px, 4vw, 64px)' }}
          >
            {isZh ? intro.heading.zh : intro.heading.en}
          </h2>
          {(isZh ? intro.body.zh : intro.body.en).map((p, i) => (
            <p key={i} className="text-[15px] leading-[1.95] text-black/75 mb-5">{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export const RoastLabCapacityV2: React.FC<Props> = ({ isZh }) => {
  const { capacity } = ROAST_LAB_CONTENT;
  return (
    <section className="bg-black text-white">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24">
        <h2
          className="mb-16 leading-[1.1]"
          style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(34px, 4vw, 64px)' }}
        >
          {isZh ? capacity.heading.zh : capacity.heading.en}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-10">
          {capacity.items.map((it, i) => (
            <div key={i} className="border-t border-white/25 pt-6">
              <p className="text-xs tracking-[0.25em] uppercase text-white/60 mb-3">
                {isZh ? it.label.zh : it.label.en}
              </p>
              <p
                className="text-white"
                style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(24px, 2.4vw, 38px)' }}
              >
                {isZh ? it.value.zh : it.value.en}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const RoastLabProcessV2: React.FC<Props> = ({ isZh }) => {
  const { process } = ROAST_LAB_CONTENT;
  return (
    <section style={{ background: '#FAF9F1' }}>
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24">
        <h2
          className="mb-16 leading-[1.1] text-black"
          style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(34px, 4vw, 64px)' }}
        >
          {isZh ? process.heading.zh : process.heading.en}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
          {process.steps.map((s) => (
            <div key={s.n} className="border-t border-black pt-6">
              <p className="text-xs tracking-[0.3em] text-black/50 mb-4">{s.n}</p>
              <h3
                className="text-2xl text-black mb-4 leading-tight"
                style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 500 }}
              >
                {isZh ? s.title.zh : s.title.en}
              </h3>
              <p className="text-sm leading-[1.85] text-black/70">{isZh ? s.desc.zh : s.desc.en}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const RoastLabPricingV2: React.FC<Props> = ({ isZh }) => {
  const { pricing } = ROAST_LAB_CONTENT;
  return (
    <section className="bg-white border-t border-black/10">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-24">
        <h2
          className="mb-6 leading-[1.1] text-black"
          style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(34px, 4vw, 60px)' }}
        >
          {isZh ? pricing.heading.zh : pricing.heading.en}
        </h2>
        <p className="text-sm text-black/60 mb-12 max-w-2xl">{isZh ? pricing.note.zh : pricing.note.en}</p>
        <div className="border-t border-black">
          {pricing.rows.map((r, i) => (
            <div key={i} className="grid grid-cols-12 py-6 border-b border-black/15 items-center">
              <div className="col-span-4 text-base text-black" style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 500 }}>
                {isZh ? r.tier.zh : r.tier.en}
              </div>
              <div className="col-span-4 text-sm text-black/70">{isZh ? r.qty.zh : r.qty.en}</div>
              <div className="col-span-4 text-right text-base text-black" style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400 }}>
                {isZh ? r.fee.zh : r.fee.en}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
